import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["actionId", "getHeaderTitle", "actionMetadata"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import CreateSalesforceCampaignActionDetail from 'automation-ui-action-features/actions/create-salesforce-campaign/CreateSalesforceCampaignActionDetail';
import CreateSalesforceCampaignActionMetadata from 'automation-ui-action-features/actions/create-salesforce-campaign/CreateSalesforceCampaignActionMetadata';
import { jsx as _jsx } from "react/jsx-runtime";
class CreateSalesforceCampaignActionCard extends Component {
  render() {
    const _this$props = this.props,
      {
        actionId,
        getHeaderTitle,
        actionMetadata
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, rest, {
      headerTitle: getHeaderTitle({
        actionId: actionId
      }),
      content: /*#__PURE__*/_jsx(CreateSalesforceCampaignActionDetail, {
        actionMetadata: actionMetadata
      })
    }));
  }
}
CreateSalesforceCampaignActionCard.propTypes = {
  getHeaderTitle: PropTypes.func.isRequired,
  actionMetadata: PropTypes.instanceOf(CreateSalesforceCampaignActionMetadata).isRequired,
  actionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};
CreateSalesforceCampaignActionCard.defaultProps = {
  isSelected: false,
  isHighlighted: false,
  isLoading: false
};
export default CreateSalesforceCampaignActionCard;